var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("Not Found")]),_c('p',[_vm._v("Woops! Looks like the page you requested cannot be found.")])])
}]

export { render, staticRenderFns }